import React, { useState } from 'react'
import { TaskCard } from '../../types/task-board'

interface TaskCardDueDateProps {
  card: TaskCard
  onUpdateDueDates: (dueDate: string | null, dueDateTo: string | null) => Promise<void>
}

const formatDateForInput = (dateString: string | null | undefined): string => {
  if (!dateString) return ''
  const date = new Date(dateString)
  return date.toISOString().slice(0, 16)
}

export const TaskCardDueDate: React.FC<TaskCardDueDateProps> = ({
  card,
  onUpdateDueDates
}) => {
  const [dueDate, setDueDate] = useState<string>(formatDateForInput(card.dueDate))
  const [dueDateTo, setDueDateTo] = useState<string>(formatDateForInput(card.dueDateTo))

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    await onUpdateDueDates(dueDate || null, dueDateTo || null)
  }

  const handleClear = async () => {
    await onUpdateDueDates(null, null)
  }

  return (
    <div className='task-card-due-date'>
      <form onSubmit={handleSubmit}>
        <div className='form-group'>
          <label htmlFor='dueDate'>Termin wykonania od</label>
          <input
            type='datetime-local'
            className='form-control'
            id='dueDate'
            value={dueDate}
            onChange={(e) => setDueDate(e.target.value)}
          />
        </div>
        <div className='form-group'>
          <label htmlFor='dueDateTo'>Termin wykonania do</label>
          <input
            type='datetime-local'
            className='form-control'
            id='dueDateTo'
            value={dueDateTo}
            onChange={(e) => setDueDateTo(e.target.value)}
          />
        </div>
        <div className='d-flex justify-content-between tw-gap-2 mt-3'>
          <button
            type='button'
            className={`
                  tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors tw-text-white
                  tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-dark-teal hover:tw-bg-dark-teal/80 focus:tw-bg-dark-teal
                `}
            onClick={handleClear}
          >
            Wyczyść termin
          </button>

          <button
            type='submit'
            className={`
                  tw-mr-2 tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors tw-text-white
                  tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base tw-bg-green hover:tw-bg-opacity-90 focus:tw-bg-green
                `}
          >
            Zapisz termin
          </button>
        </div>
      </form>
    </div>
  )
}
